import store from '@/state/store'

export default [
  {
    path: '/',
    name: 'home',
    meta: {
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        next({ name: 'cadastro-produto' })
      }
    },
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('./views/account/login'),
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (store.getters['keycloak/authenticated']) {
          // Redirect to the home page instead
          next({ name: 'home' })
        } else {
          // Continue to the login page
          next()
        }
      },
    },
  },
  {
    path: '/cadastro-ajuda',
    name: 'cadastro-ajuda',
    pageTitle:"AJUDA",
    meta: {
      authRequired: true,
      // permissions: []
    },
    component: () => import('./views/ajuda/cadastro-ajuda'),
  },
  {
    path: '/cadastro-basico',
    name: 'cadastro-basico',
    pageTitle: 'CADASTRO BÁSICO',
    meta: {
      authRequired: true,
      // permissions: []
    },
    component: () => import('./views/cadastro/cadastro-basico'),
  },
  {
    path: '/taxonomia',
    name: 'taxonomia',
    pageTitle: 'TAXONOMIA',
    meta: {
      authRequired: true,
      // permissions: []
    },
    component: () => import('./views/taxonomia/taxonomia'),
  },
  {
    path: '/iconografia',
    name: 'iconografia',
    pageTitle: 'ICONOGRAFIA',
    meta: {
      authRequired: true,
      // permissions: []
    },
    component: () => import('./views/taxonomia/iconografia'),
  },
  {
    path: '/estudio',
    name: 'estudio',
    pageTitle: 'ESTÚDIO',
    meta: {
      authRequired: true,
      // permissions: []
    },
    component: () => import('./views/cadastro/estudio'),
  },
  {
    path: '/empresa',
    name: 'empresa',
    pageTitle: 'EMPRESA',
    meta: {
      authRequired: true,
      // permissions: []
    },
    component: () => import('./views/cadastro/empresa'),
  },
  {
    path: '/cadastro-categoria',
    name: 'cadastro-categoria',
    pageTitle: 'CADASTRO DE CATEGORIA',
    meta: {
      authRequired: true,
      // permissions: []
    },
    component: () => import('./views/taxonomia/cadastro-categoria'),
  },
  {
    path: '/produtos-nao-cadastrados',
    name: 'produtos-nao-cadastrados',
    pageTitle: 'PRODUTOS NÃO CADASTRADOS',
    meta: {
      authRequired: true,
      // permissions: []
    },
    component: () => import('./views/produto/nao-cadastrados/nao-cadastrados'),
  },
  {
    path: '/categorizar-produto',
    name: 'categorizar-produto',
    pageTitle: 'CATEGORIZAR PRODUTO',
    meta: {
      authRequired: true,
      // permissions: []
    },
    component: () => import('./views/produto/categorizar/categorizar'),
  },
  {
    path: '/cadastro-produto',
    name: 'cadastro-produto',
    pageTitle: 'CADASTRO DE PRODUTOS BAGAROTE',
    meta: {
      authRequired: true,
      // permissions: []
    },
    component: () => import('./views/produto/cadastrar/cadastrar'),
  },
  {
    path: '/produtos-sem-cadastro',
    name: 'produtos-sem-cadastro',
    pageTitle: 'LISTAGEM DE PRODUTOS SEM IMAGEM',
    meta: {
      authRequired: true,
      // permissions: []
    },
    component: () => import('./views/fotografia/sessao-fotografica/produtos-sem-cadastro'),
  },
  {
    path: '/sessao-fotografica',
    name: 'sessao-fotografica',
    meta: {
      authRequired: true,
      // permissions: []
    },
    component: () => import('./views/fotografia/sessao-fotografica/sessao-fotografica'),
  },
  {
    path: '/validar-fotografia',
    name: 'validar-fotografia',
    pageTitle: 'VALIDAR FOTOGRAFIA',
    meta: {
      authRequired: true,
      // permissions: []
    },
    component: () => import('./views/fotografia/validar-fotografia/validar-fotografia'),
  },
  {
    path: '/tratamento-imagem',
    name: 'tratamento-imagem',
    pageTitle: 'TRATAMENTO DE IMAGEM',
    meta: {
      authRequired: true,
      // permissions: []
    },
    component: () => import('./views/fotografia/tratamento-imagem'),
  },
  {
    path: '/validar-tratamento',
    name: 'validar-tratamento',
    pageTitle: 'VALIDAR TRATAMENTO DE IMAGEM',
    meta: {
      authRequired: true,
      // permissions: []
    },
    component: () => import('./views/fotografia/validar-tratamento/validar-tratamento'),
  },
  {
    path: '/banco-imagens',
    name: 'banco-imagens',
    pageTitle: 'BANCO DE IMAGENS',
    meta: {
      authRequired: true,
      // permissions: []
    },
    component: () => import('./views/fotografia/banco-imagens/banco-imagens'),
  },

  {
    path: '/cadastro-usuario',
    name: 'cadastro-usuario',
    pageTitle: 'CADASTRO DE USUÁRIO',
    meta: {
      authRequired: true,
      //permissions: []
    },
    component: () => import('./views/usuario/cadastro-usuario'),
  },
  {
    path: '/cadastro-perfil',
    name: 'cadastro-perfil',
    pageTitle: 'CADASTRO DE PERFIL',
    meta: {
      authRequired: true,
      //permissions: []
    },
    component: () => import('./views/usuario/cadastro-perfil'),
  },
  {
    path: '/reset-senha',
    name: 'reset-senha',
    pageTitle:'ATUALIZAÇÃO DE SENHA',
    meta: {
      authRequired: true,
      // permissions: []
    },
    component: () => import('./views/usuario/reset-senha'),
  },
  {
    path: '/404',
    name: '404',
    component: require('./views/utility/404').default,
  },
  // Redirect any unmatched routes to the 404 page. This may
  // require some server configuration to work in production:
  // https://router.vuejs.org/en/essentials/history-mode.html#example-server-configurations
  {
    path: '*',
    redirect: '404',
  }
]
